export default __webpack_public_path__ + "static/media/down.e56d22d7.svg";